module.exports = __webpack_public_path__ + "img/cooperation.f4e0f9ab.png";